import { render } from "./index.vue?vue&type=template&id=8f4709e2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "../style/existingBuilding.scss?vue&type=style&index=0&id=8f4709e2&lang=scss&scoped=true&external"
import "../style/common.scss?vue&type=style&index=1&id=8f4709e2&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f4709e2"]])

export default __exports__